import { render, staticRenderFns } from "./stats-store.vue?vue&type=template&id=3a4df6ac&scoped=true"
import script from "./stats-store.vue?vue&type=script&lang=js"
export * from "./stats-store.vue?vue&type=script&lang=js"
import style0 from "./stats-store.vue?vue&type=style&index=0&id=3a4df6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4df6ac",
  null
  
)

export default component.exports